import {
  PARTICIPANTS_ALL_CATEGORY,
  PARTICIPANTS_NAMES_CATEGORY,
} from 'containers/AwarenessCenter/constants'

export const participantsInfoFromSearchResults = (rows = []) => {
  const tree = {}

  rows.forEach(({ name, tag, mail }) => {
    if (!tree[tag]) {
      tree[tag] = {}
    }

    if (tag === PARTICIPANTS_NAMES_CATEGORY) {
      if (!mail) {
        return
      }
      tree[tag][mail] = { full_name: name, mail }
    } else {
      tree[tag][name] = ''
    }
  })

  return tree
}

export const parseData = (data) => {
  const values = []

  Object.keys(data).forEach((key) => {
    data[key].forEach((value) => {
      if (key === PARTICIPANTS_ALL_CATEGORY) {
        values.push(key)
      } else {
        values.push(`${key}///${value}`)
      }
    })
  })

  return values
}
